import React from 'react';
import { upperFirst } from 'lodash';
import { t } from 'Src/i18n';
import { classnames } from 'Utils/classnames/classnames.utils';
import { ProgressBar } from 'Components/frameworks/progress-bar/ProgressBar';
import { TemplateString } from 'Components/frameworks/template-string/TemplateString';
import { GreatMembersIcon } from 'Components/widgets/great-members-icon/GreatMembersIcon';
type Props = {
  className?: string;
  loyaltyProgram: Array<LoyaltyProgram>;
  profile: {
    isPlatinumForLife?: boolean;
    points: number;
    status: GreatMembersStatus;
  };
};
export const GreatMemberStatus = ({ className, loyaltyProgram, profile }: Props) => {
  if (!profile) {
    return null;
  }

  const { isPlatinumForLife } = profile;
  const currentProgramIndex = loyaltyProgram.findIndex(({ status }) => status === profile.status);
  const currentProgram = loyaltyProgram[currentProgramIndex];
  const nextProgram =
    loyaltyProgram[currentProgramIndex + 1] || loyaltyProgram[loyaltyProgram.length - 1];

  if (!currentProgram) {
    return null;
  }

  const showProgressBar = !isPlatinumForLife && nextProgram.status !== currentProgram.status;
  return (
    <div
      className={classnames(
        'flex-wrap overflow-hidden rounded-12 bg-white shadow sm:flex',
        className,
      )}
    >
      <div className="flex w-full flex-col items-center justify-center bg-lightSand p-20 text-black md:py-40">
        <GreatMembersIcon className="text-black" status={profile.status} width="20rem" />
        {isPlatinumForLife ? (
          <p className="mt-15 font-brand text-18">
            {t('customerAccount.greatMember.platinumForLife')}
          </p>
        ) : (
          <p className="mt-15 font-brand text-18">
            {t('customerAccount.profile.GMPointsLabel', {
              currentPoints: profile.points,
            })}
          </p>
        )}
      </div>

      {showProgressBar && (
        <div className="w-full p-20">
          <p className="flex justify-between font-brand text-14 sm:text-16">
            <span className={`text-gm-${currentProgram.status}`}>
              {upperFirst(currentProgram.status)}
            </span>{' '}
            <span className={`text-gm-${nextProgram.status}`}>
              {upperFirst(nextProgram.status)}
            </span>
          </p>
          <ProgressBar
            color={`gm-${profile.status}`}
            max={nextProgram.threshold}
            theme="rounded"
            value={profile.points}
          />
          <p className="mt-10 text-center text-12 sm:text-14">
            <TemplateString
              template={t('customerAccount.greatMember.introduction.userStatus.missingPointsLabel')}
              values={{
                missingPoints: nextProgram.threshold - profile.points,
                nextStatus: nextProgram.status,
              }}
              valuesClassName={{
                missingPoints: 'font-brand text-16 sm:text-18',
              }}
            />
          </p>
        </div>
      )}
    </div>
  );
};
